import { createContext } from 'react';
import uuid from 'react-uuid';
import { decorate, observable, action, toJS } from 'mobx';

import api from '../api';
import * as fn from '../utilities/_functions';

export class PrescriptionPrintTemplateCreate {
    id = null;
    data = {
        name: null,
        descriptionHtml: null,
        prescriptionTypeId: null,
    };
    isReady = false;
    isSaving = false;
    hasUnsavedChanges = false;

    cancelPrescriptionPrintTemplateCreate = null;

    initialize = () => {
        this.clear();
        this.id = uuid();
        this.isReady = true;
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            let option = toJS(that.data);

            api.PrescriptionPrintTemplates.create(option, (c) => { that.cancelPrescriptionPrintTemplateCreate = c })
                .then(({ data }) => {
                    that.id = data.id;
                    that.hasUnsavedChanges = false;
                    option.id = data.id;
                    resolve(option);
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.isSaving = false;
                })
        })
    }

    clear = () => {
        this.id = null;
        this.data.name = null;
        this.data.descriptionHtml = null;
        this.data.prescriptionTypeId = null;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelPrescriptionPrintTemplateCreate)) {
            this.cancelPrescriptionPrintTemplateCreate();
            this.cancelPrescriptionPrintTemplateCreate = null;
        }
    }
}

decorate(PrescriptionPrintTemplateCreate, {
    id: observable,
    data: observable.deep,
    hasUnsavedChanges: observable,
    isReady: observable,
    isSaving: observable,
    initialize: action,
    save: action,
    clear: action,
})

export default createContext(new PrescriptionPrintTemplateCreate());